export const SITE = 'https://www.praypure.com';

export const HOME_SEO = {
    title: 'Praypure | Gomay Agarbatti & Dhoop Sticks',
    description: 'Praypure makes charcoal-free gomay agarbatti and dhoop sticks from desi cow dung. Shop incense sticks, dhup, and sambrani cups for daily puja.',
};

export const HOME_FAQS = [
    {
        question: 'What is gomay agarbatti?',
        answer: 'Gomay agarbatti is incense made with cow dung, also called gaumay or cow-dung agarbatti. Praypure sticks use desi cow dung and leave out charcoal.',
    },
    {
        question: 'Does Praypure sell incense sticks and dhoop sticks?',
        answer: 'Yes. Praypure sells agarbatti in zip pouches and stick packs, plus dhoop sticks, dhoop packs, and twelve-cup sambrani boxes.',
    },
    {
        question: 'Where can I buy Praypure agarbatti?',
        answer: 'Browse the collections on praypure.com, then buy the same packs on Amazon or Flipkart.',
    },
];

export const CATEGORY_SEO = {
    'incense-zipper-pouches': {
        title: 'Gomay Agarbatti Zip Pouches | Praypure',
        description: 'Praypure charcoal-free gomay agarbatti in 90 g zip pouches. Cow dung incense sticks for daily puja.',
        blurb: 'Charcoal-free cow dung agarbatti in 90 g zip pouches.',
    },
    'incense-sticks-100g': {
        title: 'Cow Dung Agarbatti 100g | Praypure',
        description: 'Praypure 100 g incense sticks made with gomay. Charcoal-free agarbatti for daily prayer.',
        blurb: '100 g cow dung incense sticks, made without charcoal.',
    },
    'incense-sticks-33': {
        title: 'Agarbatti 33 Sticks | Praypure Incense',
        description: 'Praypure agarbatti in packs of 33 sticks. Gomay incense for home puja.',
        blurb: 'A 33-stick pack of charcoal-free gomay agarbatti.',
    },
    'incense-packs-10': {
        title: 'Agarbatti 10 Sticks | Praypure',
        description: 'Small Praypure agarbatti packs of 10 incense sticks, made with cow dung.',
        blurb: 'Ten-stick agarbatti packs for everyday puja.',
    },
    'dhoop-sticks-100g': {
        title: 'Dhoop Sticks 100g | Praypure',
        description: 'Praypure cow dung dhoop sticks, 100 g. Charcoal-free dhup for a long sacred burn.',
        blurb: '100 g cow dung dhoop sticks for puja and dhuni.',
    },
    'dhoop-sticks-10': {
        title: 'Dhoop Sticks 10 Pack | Praypure',
        description: 'Praypure dhoop sticks in packs of 10. Gomay dhup for daily prayer.',
        blurb: 'A 10-stick pack of charcoal-free dhoop.',
    },
    'dhoop-packs-90': {
        title: 'Dhoop Stick Packs 90g | Praypure',
        description: 'Praypure 90 g dhoop stick packs made with cow dung. Dhup for home mandir.',
        blurb: '90 g dhoop stick packs made with gomay.',
    },
    'dhoop-cups': {
        title: 'Dhoop Cups | Praypure Sambrani',
        description: 'Praypure dhoop cups, twelve sambrani cups in a box, for puja and havan.',
        blurb: 'Twelve sambrani dhoop cups in each box.',
    },
    'launching-soon': {
        title: 'Coming Soon | Praypure Agarbatti',
        description: 'New Praypure agarbatti and dhoop formats, including jars and bambooless incense.',
        blurb: 'New gomay agarbatti and dhoop formats on the way.',
    },
};
